import http from '../http'

// 代理列表
export const agentList = (param) => http.get(`/api/agents/employees`, param)

// 创建代理
export const createAgent = (param) => http.post(`/api/agents/employees`, param)

// 编辑代理
export const updateAgent = (id, param) =>
  http.put(`/api/agents/employees/${id}`, param)

// 删除代理
export const deleteAgent = (id) => http.delete(`/api/agents/employees/${id}`)

// 编辑代理状态
export const updateAgentState = (id, param) =>
  http.put(`/api/agents/employees/${id}/states`, param)
